export class AgentState {
  public name = '';
  public active = false;
  public start = async () => { return true; };
  public stop = async () => { };
}